
export function getSignOutMenuItem() {

    return {
        show: true,
        navHead: {
            label: 'Sign Out',
            url: null,
            className: 'sign-out-link'
        },
        navItems: []
    }
}